/**
 * Fades the logo in once the above-fold block is scrolled past.
 */
(function() {
    'use strict';

    var aboveFoldBlock = document.querySelector('.above-fold-block');
    if (!aboveFoldBlock) return;

    var logo = document.querySelector('.site-logo');

    // Measure the header rather than repeating its height. The CSS sizes it
    // from --header-height, and that value differs by breakpoint.
    var header = document.querySelector('.site-header');
    var headerHeight = header ? header.offsetHeight : 62;

    var blockBottom = aboveFoldBlock.getBoundingClientRect().bottom;
    if (blockBottom <= headerHeight) {
        if (logo) logo.style.transition = 'none';
        document.body.classList.add('header-scrolled');
        // Two frames: the first paints the logo, the second restores the
        // transition, so a reload does not animate it in.
        if (logo) {
            requestAnimationFrame(function() {
                requestAnimationFrame(function() {
                    logo.style.transition = '';
                });
            });
        }
    }

    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            document.body.classList.toggle('header-scrolled', !entry.isIntersecting);
        });
    }, {
        threshold: 0,
        rootMargin: '-' + headerHeight + 'px 0px 0px 0px'
    });

    observer.observe(aboveFoldBlock);
})();
